import { useCallback, useEffect } from "react";
import { useAtom } from "jotai";
import { useAuth } from "./useAuth";
import { isTrialAccount } from "../components/auth/NonTrialScope";
import { consolidatedAtom } from "../store/consolidatedAtoms";

export function useConsolidated() {
  const { roles } = useAuth();
  const allowConsolidated = !isTrialAccount(roles);
  const [isConsolidated, setIsConsolidatedState] = useAtom(consolidatedAtom);

  useEffect(() => {
    if (!allowConsolidated && isConsolidated) {
      setIsConsolidatedState(false);
    }
  }, [allowConsolidated, isConsolidated, setIsConsolidatedState]);

  const setIsConsolidated = useCallback(
    (next: boolean) => {
      if (!allowConsolidated) return;
      setIsConsolidatedState(next);
    },
    [allowConsolidated, setIsConsolidatedState],
  );

  const effectiveConsolidated = allowConsolidated && isConsolidated;

  return {
    allowConsolidated,
    isConsolidated,
    setIsConsolidated,
    effectiveConsolidated,
  };
}
